import { render, staticRenderFns } from "./StatusDating.vue?vue&type=template&id=78a9a443&"
import script from "./StatusDating.vue?vue&type=script&lang=js&"
export * from "./StatusDating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports